import { ReactNode } from 'react'
import Styles from './ImageOverlay.module.scss'

interface Props {
  children: ReactNode
}

export const ImageOverlay = ({ children }: Props) => <div className={Styles.overlay}>{children}</div>
